export const state = {
    isImporting: false
};

export const reducer = {
    startImporting: (state) => {
        if ('isImporting' in (state || {})) {
            state.isImporting = true;
        }
    },
    stopImporting: (state) => {
        if ('isImporting' in (state || {})) {
            state.isImporting = false;
        }
    }
};
